import type { ReactNode } from 'react';

import { Nav } from '../components/nav/nav';
import { Footer } from '../components/footer/footer';
import { Head } from '@inertiajs/react';

type LayoutProps = {
  title?: string;
  children: ReactNode;
};

export default function Layout(props: LayoutProps) {
  const { title, children } = props;

  return (
    <>
      <Head title={title} />
      <div className="app">
        <Nav />
        <main>{children}</main>
        <Footer />
      </div>
    </>
  );
}
